export const findId = (ids: number[], id: number) => {
  return Boolean(ids.find(findId => findId === id));
};